interface currency {

}
export function format(price: number, currency: 'usd' | 'uah') {
    const numberFormat = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    });

    // const symbol = currency === 'usd' ? '$' : '₴'

    return numberFormat.format(price)
}